export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/bryan-profile-214c41c8c8cb8c82be4a8d8d035e3af5.png";